module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/nano_bg-7232e780629b2445d5ccff173bac3b9f.png";